import React, { Component } from 'react';
import { find, groupBy, get, includes, toNumber } from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';

import { storeListDMAForSelect } from '../../../../redux/general/action';
import { domainMaterial } from '../wrapper-total/table-length-by-type/domain-material';
import { domainSize } from '../wrapper-total/table-lenght-by-size/domain-size'
import { subtypes } from '../wrapper-total/subtype';
import Snipper from '../../../layout/Spinner/snipper.component';
import './wrapper-list-DMA.style.css';
import AccordinListDMA from './accordin-list-dma/accordin-list-dma.component'



export class WrapperListDMA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchField: '',
            // selectedOption: null,
        }
    }

    handleChange = selectedOption => {
        if (selectedOption) {
            this.setState({ searchField: selectedOption.value })
        } else {
            this.setState({ searchField: '' })
        }
        
        // console.log('selectedOption',selectedOption);
    };

    handleInputChange = (value) => {
        // value? this.setState({ searchField: value }) : value
        if (value) {
            this.setState({ searchField: value })
        }
    }

    getDMAID = (groupDataLengthByTypeDMA_DMAID) => {
        try {
            let arrayAllKey = Object.keys(groupDataLengthByTypeDMA_DMAID);
            return arrayAllKey;
        } catch (error) {
            console.log('Error when get DMA ID: ', error);
            return []
        }
    }

    transformObjectLengthType = (objectSource) => {
        try {
            //create data to template
            let outPutArray = [];
            for (let key in objectSource) {
                let newObject = {};
                newObject['id'] = key;
                newObject['category'] = subtypes[key];
                let arrayTam = objectSource[key];
                let total = 0;
                for (let i = 0; i < arrayTam.length; i++) {
                    const nameKey = arrayTam[i]['MATERIAL'];
                    newObject[`${nameKey}`] = { 'name': domainMaterial[nameKey], 'value': toNumber(arrayTam[i]['LenghtOfMaterial']).toFixed(2) }
                    total += toNumber(arrayTam[i]['LenghtOfMaterial']);
                }
                newObject['total'] = total.toFixed(2);
                outPutArray.push(newObject);
            }

            //initial arrayKey
            let initialArrayKey = Object.keys(outPutArray[0]);
            outPutArray.map((element) => {
                for (const key in element) {
                    if (!initialArrayKey.includes(key)) {
                        initialArrayKey.push(key);
                    }
                }
                return ''
            });

            //loop outPutArray, to add default zero length to material
            let finalArray = outPutArray.map((element) => {
                initialArrayKey.map((element2) => {
                    let arrayKeyOfOutputArray = Object.keys(element);
                    if (!arrayKeyOfOutputArray.includes(element2)) {
                        element[`${element2}`] = { 'name': domainMaterial[element2], 'value': 0 }
                    }
                    return ''
                });
                return { ...element }
            });
            return finalArray;
        } catch (error) {
            console.log('Error transformObjectLengthType: ', error);
            return {}
        }
    }

    transformObjectSizeType = (objectSource) => {
        try {
            //create data to template
            let outPutArray = [];
            for (let key in objectSource) {
                let newObject = {};
                newObject['id'] = key;
                newObject['category'] = subtypes[key];
                let arrayTam = objectSource[key];
                let total = 0;
                for (let i = 0; i < arrayTam.length; i++) {
                    const nameKey = `s${arrayTam[i]['NOMINALDIAMETER']}`;
                    newObject[`${nameKey}`] = { 'name': domainSize[nameKey], 'value': toNumber(arrayTam[i]['LenghtOfMeterSize']).toFixed(2) }
                    total += toNumber(arrayTam[i]['LenghtOfMeterSize']);
                }
                newObject['total'] = total.toFixed(2);
                outPutArray.push(newObject);
            }



            //initial arrayKey
            let initialArrayKey = Object.keys(outPutArray[0]);
            outPutArray.map((element) => {
                for (const key in element) {
                    if (!initialArrayKey.includes(key)) {
                        initialArrayKey.push(key);
                    }
                }
                return ''
            });

            //loop outPutArray, to add default zero length to material
            let finalArray = outPutArray.map((element) => {
                initialArrayKey.map((element2) => {
                    let arrayKeyOfOutputArray = Object.keys(element);
                    if (!arrayKeyOfOutputArray.includes(element2)) {
                        element[`${element2}`] = { 'name': domainSize[element2], 'value': 0 }
                    }
                    return ''
                });
                return { ...element }
            });
            return finalArray;
        } catch (error) {
            console.log('Error transformObjectSizeType: ', error);
            return {}
        }
    }

    formatDetailLengthType = (arrayDetailInfo) => {
        try {
            //group data by type
            let groupDataLengthByType = groupBy(arrayDetailInfo, 'TYPE');
            // console.log('groupDataLengthByType: ',groupDataLengthByType );
            let finalData = this.transformObjectLengthType(groupDataLengthByType);
            // console.log('finalData: ',finalData);
            return finalData;

        } catch (error) {
            console.log('Error formatDetailLengthType: ',);
        }
    }

    formatDetailSizeType = (arrayDetailInfo) => {
        try {
            //group data by type
            let groupDataSizeByType = groupBy(arrayDetailInfo, 'TYPE');
            // console.log('groupDataLengthByType: ',groupDataLengthByType );
            let finalData = this.transformObjectSizeType(groupDataSizeByType);
            // console.log('finalData: ',finalData);
            return finalData;

        } catch (error) {
            console.log('Error formatDetailSizeType: ',);
        }
    }

    formatLengthTypeDMA = (groupLengthTypeByDMA) => {
        try {
            //create data to template
            let outPutArray = [];
            for (let key in groupLengthTypeByDMA) {
                let newObject = {};
                newObject['dmaid'] = key;
                newObject['length'] = groupLengthTypeByDMA[key];
                outPutArray.push(newObject);
            }

            //create data to template
            let outPutArrayTemplate = [];
            outPutArrayTemplate = outPutArray.map((element) => {
                let arrayDetailInfo = element.length;
                element['length'] = this.formatDetailLengthType(arrayDetailInfo);
                return { ...element }
            });

            // console.log('outPutArray: ',outPutArray);
            // console.log('outPutArrayTemplate: ',outPutArrayTemplate);
            return outPutArrayTemplate;
        } catch (error) {
            console.log('Error formatLengthTypeDMA: ', error);
            return {}
        }
    }

    formatSizeTypeDMA = (groupSizeTypeByDMA) => {
        try {

            //create data to template
            let outPutArray = [];
            for (let key in groupSizeTypeByDMA) {
                let newObject = {};
                newObject['dmaid'] = key;
                newObject['size'] = groupSizeTypeByDMA[`${key}`];
                outPutArray.push(newObject);
            }

            //create data to template
            let outPutArrayTemplate = [];
            outPutArrayTemplate = outPutArray.map((element) => {
                let arrayDetailInfo = element.size;
                element['size'] = this.formatDetailSizeType(arrayDetailInfo);
                return { ...element }
            });

            // console.log('outPutArray: ',outPutArray);
            // console.log('outPutArrayTemplate: ',outPutArrayTemplate);
            return outPutArrayTemplate;
        } catch (error) {
            console.log('Error formatSizeTypeDMA: ', error);
            return {}
        }
    }


    groupLengthTypeByDMA = (dataLengthByTypeDMA) => {
        try {
            //customize dataLengthByType from [{attributes: {xxx}},{attributes: {yyy}},...] => [{xxx},{yyy},...]
            let cusDataLengthByTypeDMA = dataLengthByTypeDMA.map((element) => {
                return { ...element['attributes'] }
            });
            //group data by type
            let groupDataLengthByTypeDMA_DMAID = groupBy(cusDataLengthByTypeDMA, 'DMAID');

            return groupDataLengthByTypeDMA_DMAID;

        } catch (error) {
            console.log('Error formatSizeTypeDMA: ',);
        }
    }

    groupSizeTypeByDMA = (dataSizeByTypeDMA) => {
        try {
            //customize dataLengthByType from [{attributes: {xxx}},{attributes: {yyy}},...] => [{xxx},{yyy},...]
            let cusDataSizeByTypeDMA = dataSizeByTypeDMA.map((element) => {
                return { ...element['attributes'] }
            });
            //group data by type
            let groupDataSizeByTypeDMA_DMAID = groupBy(cusDataSizeByTypeDMA, 'DMAID');

            return groupDataSizeByTypeDMA_DMAID;

        } catch (error) {
            console.log('Error groupSizeTypeByDMA: ',);
        }
    }

    render() {
        const groupLengthTypeByDMA = this.groupLengthTypeByDMA(this.props.dataLengthByTypeDMA);
        const groupSizeTypeByDMA = this.groupSizeTypeByDMA(this.props.dataLengthBySizeDMA);

        let outPutArrayTemplateLengthType = this.formatLengthTypeDMA(groupLengthTypeByDMA);
        let outPutArrayTemplateSizeType = this.formatSizeTypeDMA(groupSizeTypeByDMA);

        const arrayDMAIDS = this.getDMAID(groupLengthTypeByDMA);
        const { searchField } = this.state;

        const filteredDMAIDs = arrayDMAIDS.filter(dmaid => dmaid.toLowerCase().includes(searchField.toLowerCase()));

        const options = this.props.listDMAForSelect;

        return (
            <div className="wrapper-list-DMA">
                <div className="container-name-and-export-exel-button">
                    <h1 className="name-element-list-dma-box">List DMA</h1>
                    {/* <button className="button-export-excel w-button">Export to excel</button> */}
                </div>
                <div>
                    <div className="container-for-input-search">
                        {/* <input className="input-seach-box" placeholder='Input ID DMA to search'
                            onChange={e => { this.setState({ searchField: e.target.value }) }}
                        /> */}

                        <Select
                            // value={selectedOption}
                            onChange={this.handleChange}
                            options={options}
                            onInputChange={this.handleInputChange}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            placeholder="Select DMA ID..."
                            isClearable='true'
                        // isMulti = 'true'
                        />
                    </div>
                </div>
                {this.props.loadingDMAList ? (<Snipper />) : (<div className="list-dma">
                    {filteredDMAIDs.map((dmaid, idx) => {
                        return <AccordinListDMA
                            key={idx}
                            dmaName={dmaid}
                            dataLengthByTypeDMA={find(outPutArrayTemplateLengthType, ['dmaid', dmaid])}
                            dataLengthBySizeDMA={find(outPutArrayTemplateSizeType, ['dmaid', dmaid])}
                            loadingDMAList={this.props.loadingDMAList}
                        />
                    })}
                </div>)}

            </div>
        )
    }
}

// export default WrapperListDMA

const mapStateToProps = state => ({
    listDMAForSelect: get(state, 'GeneralStore.listDMAForSelect')
})

const mapDispatchToProps = dispatch => {
    return {
        storeListDMAForSelect: listDMAForSelect => {
            dispatch(storeListDMAForSelect(listDMAForSelect))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WrapperListDMA)
